module.exports = __webpack_public_path__ + "static/media/monitoria.60eb9136.png";